import { Breadcrumb } from '@fukuri-admins/ui/common';
import { useStressAssessmentReportBreadcrumb } from '~/usecases/useStressAssessmentReportBreadcrumb';
import { convertToBreadcrumbItems } from './logics';

type Props = {
  stressAssessmentId: number;
};

export const StressAssessmentReportDownloadBreadcrumb: React.FC<Props> = ({
  stressAssessmentId,
}) => {
  const { data } = useStressAssessmentReportBreadcrumb({ stressAssessmentId });
  if (!data) return null;

  const { items } = convertToBreadcrumbItems({ data, stressAssessmentId });

  return <Breadcrumb items={items} />;
};
